
import { ProfilePictureCard } from "./ProfilePictureCard";
import { MembershipCard } from "./MembershipCard";
import { PersonalInfoCard } from "./PersonalInfoCard";
import { Profile } from "@/hooks/useProfileData";

interface SettingsContentProps {
  profile: Profile;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  onAvatarUpdate: (url: string) => void;
  onProfileUpdate: (profile: Profile) => void;
}

export function SettingsContent({
  profile,
  isLoading,
  setIsLoading,
  onAvatarUpdate,
  onProfileUpdate
}: SettingsContentProps) {
  return (
    <main className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-white">Settings</h1>
        <p className="text-white/70">Manage your profile and preferences</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-1 grid grid-rows-2 gap-6">
          <div className="h-full">
            <ProfilePictureCard 
              avatar_url={profile.avatar_url}
              full_name={profile.full_name}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              onAvatarUpdate={onAvatarUpdate}
            />
          </div>
          
          <div className="h-full">
            <MembershipCard tier={profile.tier || 'Beta'} />
          </div>
        </div>

        <div className="col-span-1 h-full">
          <PersonalInfoCard 
            profile={profile}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onProfileUpdate={onProfileUpdate}
          />
        </div>
      </div>
    </main>
  );
}
